export default "__VITE_ASSET__CihX4dW1__"